var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.15608 12.9061L6.06975 11.5628L7.19199 12.3156L7.65124 11.5076L6.43923 10.9171L7.65124 10.3267L7.19199 9.51865L6.06975 10.2714L6.15608 8.92818H5.23412L5.32044 10.2714L4.1982 9.51865L3.73895 10.3267L4.95097 10.9171L3.73895 11.5076L4.1982 12.3156L5.32044 11.5628L5.23412 12.9061H6.15608ZM16.3373 12.9061L16.251 11.5628L17.3732 12.3156L17.8325 11.5076L16.6205 10.9171L17.8325 10.3267L17.3732 9.51865L16.251 10.2714L16.3373 8.92818H15.4154L15.5017 10.2714L14.3795 9.51865L13.9202 10.3267L15.1322 10.9171L13.9202 11.5076L14.3795 12.3156L15.5017 11.5628L15.4154 12.9061H16.3373Z",
    fill: "#2E75CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2467 12.9061L11.1604 11.5628L12.2826 12.3156L12.7419 11.5076L11.5299 10.9171L12.7419 10.3267L12.2826 9.51865L11.1604 10.2714L11.2467 8.92818H10.3247L10.4111 10.2714L9.28883 9.51865L8.82958 10.3267L10.0416 10.9171L8.82958 11.5076L9.28883 12.3156L10.4111 11.5628L10.3247 12.9061H11.2467Z",
    fill: "#95AFCB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIcon);
export default __webpack_public_path__ + "static/media/password_icon.3acdbf798f207650ca121cebd76991f9.svg";
export { ForwardRef as ReactComponent };